<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="项目编号"><el-input v-model="query.projectCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="项目名称"><el-input v-model="query.projectName" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="阶段">
        <el-select v-model="query.currentStage" clearable size="small" style="width:110px">
          <el-option label="概念" value="concept" /><el-option label="设计" value="design" />
          <el-option label="试制" value="pilot" /><el-option label="量产" value="released" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmProject:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('plm:plmProject:save')" type="primary" size="small" @click="open()">立项</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="projectCode" label="项目编号" min-width="130" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('plm:plmProject:info')" class="code-link" @click="open(scope.row, true)">{{ scope.row.projectCode }}</a>
          <span v-else>{{ scope.row.projectCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="项目名称" min-width="160" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="materialCode" label="目标物料" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="currentStage" label="当前阶段" width="90" header-align="center" align="center">
        <template slot-scope="scope">{{ stageLabel(scope.row.currentStage) }}</template>
      </el-table-column>
      <el-table-column prop="projectStatus" label="状态" width="80" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.projectStatus === 'closed' ? 'info' : 'success'" size="mini">{{ scope.row.projectStatus === 'closed' ? '已关闭' : '进行中' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" header-align="center" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="isAuth('plm:plmPilotOrder:save') && scope.row.projectStatus !== 'closed' && scope.row.materialId && ['design', 'pilot'].includes(scope.row.currentStage)" type="text" size="small" @click="pilotHandle(scope.row)">试制工单</el-button>
          <el-button v-if="(isAuth('plm:plmProject:handoff') || isAuth('plm:plmProject:update')) && scope.row.currentStage === 'pilot' && scope.row.projectStatus !== 'closed'" type="text" size="small" @click="handoffHandle(scope.row.projectId)">移交量产</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog :visible.sync="visible" width="min(720px, calc(100vw - 24px))" :close-on-click-modal="false">
      <template slot="title">
        <div class="doc-dialog-header">
          <span class="doc-dialog-title">{{ dialogTitle }}</span>
          <div v-if="readonly && form.projectId" class="doc-dialog-actions">
            <el-button-group>
              <el-button v-if="isAuth('plm:plmProject:update') || isAuth('plm:plmProject:save')" type="primary" size="small" :disabled="form.projectStatus === 'closed'" @click="editFromView">修改</el-button>
              <el-button v-if="isAuth('plm:plmProject:delete') || isAuth('plm:plmProject:save')" type="danger" size="small" :disabled="form.projectStatus === 'closed'" @click="deleteFromView">删除</el-button>
            </el-button-group>
          </div>
        </div>
      </template>
      <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" label-width="136px" :disabled="readonly">
        <el-form-item label="项目编号" prop="projectCode"><el-input v-model="form.projectCode" :disabled="!!form.projectId" /></el-form-item>
        <el-form-item label="项目名称" prop="projectName"><el-input v-model="form.projectName" /></el-form-item>
        <el-form-item label="目标物料">
          <el-input v-model="form.materialCode" readonly placeholder="点击选择">
            <el-button v-if="!readonly" slot="append" @click="materialSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="目标MBOM版本"><el-input v-model="form.targetMbomVersion" placeholder="量产移交时发布的版本" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <div v-if="form.projectId && form.gates && form.gates.length" style="margin-top:12px">
        <div style="margin-bottom:8px;font-weight:600">阶段门</div>
        <el-table :data="form.gates" border size="small" :header-cell-style="headStyle">
          <el-table-column prop="gateName" label="阶段门" min-width="120" />
          <el-table-column prop="gateStatus" label="状态" width="90" align="center">
            <template slot-scope="scope">{{ scope.row.gateStatus === 'pass' ? '已通过' : '待通过' }}</template>
          </el-table-column>
          <el-table-column prop="passDate" label="通过时间" width="140" />
          <el-table-column v-if="!readonly || canPassGate" label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.gateStatus !== 'pass' && scope.row.gateCode === form.currentStage && scope.row.gateCode !== 'released' && canPassGate && form.projectStatus !== 'closed'" type="text" size="small" @click="passGate(scope.row)">通过</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button @click="visible = false">关闭</el-button>
        <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
      </span>
    </el-dialog>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector.vue'

export default {
  name: 'PlmProject',
  components: { MaterialSelector },
  data() {
    return {
      query: { projectCode: '', projectName: '', currentStage: '' },
      list: [], pageIndex: 1, pageSize: 10, loading: false, visible: false, readonly: false,
      materialSelectorVisible: false, permCodes: [], form: {},
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: {
        projectCode: [{ required: true, message: '项目编码不能为空', trigger: 'blur' }],
        projectName: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看NPI项目'
      return this.form.projectId ? '修改NPI项目' : '新增NPI项目'
    },
    canPassGate() {
      return this.isAuth('plm:plmProjectGate:pass') || this.isAuth('plm:plmProject:update') || this.isAuth('plm:plmProject:save')
    },
    filtered() {
      return this.list.filter(row => this.has(row.projectCode, this.query.projectCode) && this.has(row.projectName, this.query.projectName) && (!this.query.currentStage || row.currentStage === this.query.currentStage))
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    has(value, keyword) {
      const text = String(keyword || '').trim().toLowerCase()
      if (!text) return true
      return String(value || '').toLowerCase().indexOf(text) >= 0
    },
    stageLabel(s) {
      const map = { concept: '概念', design: '设计', pilot: '试制', released: '量产' }
      return map[s] || s
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/project/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    editFromView() {
      if (this.form.projectStatus === 'closed') return
      this.readonly = false
    },
    deleteFromView() {
      if (this.form.projectStatus === 'closed') {
        this.$message.warning('已关闭的项目不可删除')
        return
      }
      this.$confirm('确定删除该项目?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/project/delete', { id: this.form.projectId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    onMaterialSelect(row) {
      this.form.materialId = row.materialId
      this.form.materialCode = row.materialCode
      this.form.materialName = row.materialName
      this.materialSelectorVisible = false
    },
    open(row, readonly) {
      this.readonly = !!readonly
      this.visible = true
      const blank = () => ({
        projectId: '', projectCode: '', projectName: '', currentStage: 'concept', projectStatus: 'open',
        materialId: '', materialCode: '', materialName: '', targetMbomVersion: '', remark: '', gates: []
      })
      if (!row || !row.projectId) {
        this.form = blank()
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
        return
      }
      request.get('/plm/project/info', { params: { id: row.projectId } }).then(res => {
        this.form = Object.assign(blank(), res.data || row)
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {
        this.form = Object.assign(blank(), row)
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      })
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/plm/project/save', {
          projectId: this.form.projectId, projectCode: this.form.projectCode, projectName: this.form.projectName,
          currentStage: this.form.currentStage, materialId: this.form.materialId,
          targetMbomVersion: this.form.targetMbomVersion, remark: this.form.remark
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.load() }).catch(() => {})
      })
    },
    pilotHandle(row) {
      this.$prompt('请输入试制数量', '下推试制工单', { inputPattern: /^[0-9]+(\.[0-9]+)?$/, inputErrorMessage: '数量格式不正确' }).then(({ value }) => {
        request.post('/plm/project/createPilotOrder', { projectId: row.projectId, quantity: value }).then(() => {
          this.$message.success('试制工单已创建（草稿），请到生产工单下达')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    handoffHandle(projectId) {
      this.$confirm('确认移交量产？将发布目标 MBOM 并关闭项目。', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/project/handoffRelease', { projectId }).then(() => {
          this.$message.success('量产移交成功')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    passGate(gate) {
      this.$prompt('通过备注（可选）', '通过阶段门', { inputValue: '' }).then(({ value }) => {
        request.post('/plm/project/passGate', { gateId: gate.gateId, passRemark: value || '' }).then(() => {
          this.$message.success('阶段门已通过')
          if (this.form.projectId) this.open({ projectId: this.form.projectId }, this.readonly)
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
</style>
